export default __webpack_public_path__ + "static/laurel-cec09143047a1f4114da37158382ba13.png";